import image1 from "assets/cursos/1/1.jpg";
import image2 from "assets/cursos/2/2.jpg";
import image3 from "assets/cursos/3/3.jpg";
import image4 from "assets/cursos/4/4.jpg";
import image5 from "assets/cursos/5/5.jpg";
import image6 from "assets/cursos/6/6.jpg";
import imageNot1 from "assets/noticias/1/1.png";
import imageNot2 from "assets/noticias/2/2.jpg";
import imageNot3 from "assets/noticias/3/3.jpg";
import imageNot4 from "assets/noticias/4/4.jpg";
import imageNot5 from "assets/noticias/5/5.jpg";
import imageNot6 from "assets/noticias/6/6.jpg";
import React, { useEffect, useState } from "react";
import Carousel, { Alignment } from "nuka-carousel";
import "./style.scss";
import { api } from "services/api";
import { useSelector } from "react-redux";
import { IUser } from "types";
import { handleOpenTab, PORTAL_PUBLICO_BASE_URL } from "utils";

export const HomePage = () => {
	const [news, setNews] = useState<any[]>([]);
	const [courses, setCourses] = useState<any[]>([]);
	const [feedback, setFeedback] = useState<any>({
		news: undefined,
		courses: undefined,
	});
	const {
		user: { label, name },
	} = useSelector((state: { app: { user: IUser } }) => state.app);

	const isManager = label === "manager";

	useEffect(() => {
		api.get("/news/highlight").then((result) => {
			const {
				data: {
					data: { news },
					feedback,
				},
			} = result;
			setFeedback((prevState: any) => ({
				...prevState,
				news: { ...feedback },
			}));
			setNews(news);
		});

		api.get("/courses/highlight").then((result) => {
			const {
				data: {
					data: { courses },
					feedback,
				},
			} = result;
			setFeedback((prevState: any) => ({
				...prevState,
				courses: { ...feedback },
			}));

			setCourses(courses);
		});
	}, []);
	const imageNotArr = [
		imageNot1,
		imageNot2,
		imageNot3,
		imageNot4,
		imageNot5,
		imageNot6,
	];

	const imageArr = [image1, image2, image3, image4, image5, image6];
	return (
		<div className="home">
			{isManager && (
				<div className="home__title">
					<h1>Seja bem-vindo, Gestor(a) {name}!</h1>
					<p>Aqui estão algumas notícias relevantes sobre a plataforma:</p>
				</div>
			)}
			<div
				className="home__news-carousel"
				style={{
					marginTop: isManager ? "0px" : "",
					marginBottom: isManager ? "35px" : "",
				}}
			>
				<h1 className="home__news-carousel__title">NOTÍCIAS</h1>
				{news.length !== 0 && (
					<Carousel
						cellAlign={Alignment.Left}
						slidesToShow={5}
						renderCenterLeftControls={({ previousSlide }) => (
							<button
								className="left-row"
								onClick={previousSlide}
								style={{ transform: "rotate(180deg" }}
							>
								➜
							</button>
						)}
						renderCenterRightControls={({ nextSlide }) => (
							<button className="right-row" onClick={nextSlide}>
								➜
							</button>
						)}
					>
						{news.map((item, index) => {
							if (item) {
								return (
									<div
										key={index}
										className="home__news-carousel__card"
										onClick={() =>
											handleOpenTab(
												PORTAL_PUBLICO_BASE_URL,
												"/news/",
												`${item.id}`
											)
										}
									>
										<img
											src={
												`${process.env.REACT_APP_API_URL}`.includes(
													"apiary-mock"
												)
													? imageNotArr[index]
													: item.image
											}
											alt=""
											width="200px"
										/>
										<div className="home__news-carousel__card__info">
											<h1>{item.title ? item.title : item.title}</h1>
											<p>
												{item.description && item.description.length > 650
													? `${item.description.substring(0, 350)}...`
													: item.description
													? item.description
													: ""}
											</p>
										</div>
									</div>
								);
							}
							return null;
						})}
					</Carousel>
				)}
				{news.length === 0 && (
					<h1
						style={{
							fontSize: "30px",
							fontFamily: "Montserrat",
							fontWeight: "300",
						}}
					>
						{feedback.news
							? feedback.news["empty"]
							: "Sem conteúdo para exibir"}
					</h1>
				)}
			</div>

			{!isManager && (
				<div className="home__courses-carousel">
					<h1 className="home__courses-carousel__title">CURSOS EM DESTAQUE</h1>
					{courses.length !== 0 && (
						<Carousel
							cellAlign={Alignment.Left}
							slidesToShow={5}
							renderCenterLeftControls={({ previousSlide }) => (
								<button
									className="left-row"
									onClick={previousSlide}
									style={{ transform: "rotate(180deg" }}
								>
									➜
								</button>
							)}
							renderCenterRightControls={({ nextSlide }) => (
								<button className="right-row" onClick={nextSlide}>
									➜
								</button>
							)}
						>
							{courses.map((item, index) => {
								if (item) {
									return (
										<div
											key={index}
											className="home__courses-carousel__course-card"
											onClick={() =>
												handleOpenTab(
													PORTAL_PUBLICO_BASE_URL,
													"/course/",
													`${item.id}`
												)
											}
										>
											<div className="home__courses-carousel__course-card__img">
												<img
													src={item.image ? item.image : imageArr[1]}
													alt=""
													width="215px"
												/>
											</div>
											<div className="home__courses-carousel__course-card__info">
												<h1 className="home__courses-carousel__course-card__info__title">
													{item.title ? item.title : ""}
												</h1>
												<span className="home__courses-carousel__course-card__info__author">
													{item.author ? item.author : ""}
												</span>
												<p className="home__courses-carousel__course-card__info__description">
													{item.description && item.description.length > 280
														? `${item.description.substring(0, 280)}...`
														: item.description
														? item.description
														: ""}
												</p>
												<p className="home__courses-carousel__course-card__info__subtitle">
													Classificação indicativa: {item.age ? item.age : ""}
												</p>
											</div>
											<div className="home__courses-carousel__course-card__info__tags">
												{item?.tags?.split(",")?.map((tag: any) => (
													<p className="tag">{tag}</p>
												))}
											</div>
										</div>
									);
								}
								return null;
							})}
						</Carousel>
					)}
					{courses.length === 0 && (
						<h1
							style={{
								fontSize: "30px",
								fontFamily: "Montserrat",
								fontWeight: "300",
							}}
						>
							{feedback.courses
								? feedback.courses["empty"]
								: "Sem conteúdo para exibir"}
						</h1>
					)}
				</div>
			)}
		</div>
	);
};
